import { uuid } from '@/_core/utils/uuid';
import { BoardUserActivityType } from '@/api/workspaceSettings/queries';
import { PermanentlyDeleteCardFromTrash } from '../../../store/actions/trash/permanentlyDeleteCardFromTrash';
import { CardType, DeleteActivity, DeleteSubtask, DeleteTask } from '..';
import * as storymapStoreModule from '../../../store';

export const createPermanentDeleteFromTrashCommand = async (action: PermanentlyDeleteCardFromTrash) => {
    const store = storymapStoreModule.useStorymapStore();
    const activityId = await uuid.create();
    const row = action.row;

    const boardActivity: any = {
        CardId: row.id,
        CardName: row.title,
        Datetime: new Date().toJSON(),
        OriginalContent: row.title,
        Id: activityId,
        StorymapId: store.state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
        Type: getPermanentDeleteActivityType(row.cardType),
    };

    const command =
        row.cardType === CardType.Activity
            ? new DeleteActivity(store.state.id, row.id)
            : row.cardType === CardType.Task
                ? new DeleteTask(store.state.id, row.id)
                : new DeleteSubtask(store.state.id, row.id);

    command.BoardActivity = boardActivity;

    return command;
};

const getPermanentDeleteActivityType = (cardType: number): BoardUserActivityType => {
    switch (cardType) {
        case CardType.Activity:
            return BoardUserActivityType.ActivityPermanentlyDeleted;
        case CardType.Task:
            return BoardUserActivityType.TaskPermanentlyDeleted;
        case CardType.Subtask:
            return BoardUserActivityType.SubtaskPermanentlyDeleted;
        case CardType.UnscheduledSubtask:
            return BoardUserActivityType.UnscheduledSubtaskPermanentlyDeleted;
        default:
            return BoardUserActivityType.DoNotSaveThis;
    }
};
